import React, { useEffect, useState } from 'react';
import { http } from "../lib/axios";
import { Container, Typography, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';

export default function HostRequestsPage() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    http.get('/hostrequests/')
      .then(res => setRequests(res.data));
  }, []);

  const updateStatus = (id, status) => {

    http.patch(`/hostrequests/${id}/`, { status })
      .then(() => setRequests(prev => prev.map(r => r.id === id ? { ...r, status } : r)));
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Host Requests</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Artwork</TableCell>
            <TableCell>Host</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map(req => (
            <TableRow key={req.id}>
              <TableCell>{req.artwork_title}</TableCell>
              <TableCell>{req.host_name}</TableCell>
              <TableCell>{req.status}</TableCell>
              <TableCell>
                {req.status === 'pending' && (
                  <>
                    <Button color="success" onClick={() => updateStatus(req.id, 'approved')}>Approve</Button>
                    <Button color="error" onClick={() => updateStatus(req.id, 'rejected')}>Reject</Button>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}
